import { render, staticRenderFns } from "./theodoikyluat.vue?vue&type=template&id=f1f4ebc4"
import script from "./theodoikyluat.vue?vue&type=script&lang=js"
export * from "./theodoikyluat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports